import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactContainerComponent } from './contact-container.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { CoreParentComponent } from './components/coreParent/core-parent.component';
import { CreatePiComponent } from './components/process-intelligence/create-pi/create-pi.component';
import { ContactListingComponent } from './components/contact-listing/contact-listing.component';
import { KanbanContactViewComponent } from './components/kanban-view/kanban-view.component';


const routes: Routes = [
  { path: '', component: ContactContainerComponent },
  { path: 'kanbanview', component: KanbanContactViewComponent },
  { path: 'listing', component: ContactListingComponent },
  { path: 'documents', component: CoreParentComponent },
  { path: 'documentList', component: DocumentsComponent },
  { path: 'process', component: CreatePiComponent }
  
];

// const routes: Routes = [
//   {
//     path: '',
//     component: ContactContainerComponent,
//     children: [
//       {
//         path:'listing',
//         component: ContactListingComponent
//       },
//       {
//         path:'documents',
//         component: CoreParentComponent
//       },
//       {
//         path: 'documentList',
//         component: DocumentsComponent
//       },
//       {
//         path: 'process',
//         component: CreatePiComponent
//       }
//     ]
//   }
// ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactRoutingModule { }
